// extracted by mini-css-extract-plugin
export default {"linkInput":"UHlVstyk9BzRzoPo7STy"};